import template from './headerSS.html';
import './headerSS.scss';

let headerSS = {
  restrict: 'E',
  transclude: true,
  bindings: {},
  template,
};

export default headerSS;



// WEBPACK FOOTER //
// ./client/app/social-security.module/features/socialSecurity/headerSS/headerSS.component.js